import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

import NeighborsScanTab from './NeighborsScanTab';
import NeighborsReportsList from './NeighborsReportsList';

// NeighborsTabContainer hosts the two sub-views of the top-level
// Neighbours tab:
//
//   * "All Reports" — table of every connected jnet2 Node and the
//     timestamp of its most recent neighbour-scan report (clicking a
//     row opens the per-device Neighbours Scan Report page).
//   * "Run Scan" — the existing scan-trigger workflow.
const NeighborsTabContainer = ({ devices, allowNeighborsScan = true }) => {
  const [tab, setTab] = useState(0);
  return (
    <Box>
      {allowNeighborsScan && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tab} onChange={(_, v) => setTab(v)} aria-label="Neighbours sub-tabs">
            <Tab label="All Reports" id="neighbors-subtab-0" aria-controls="neighbors-subpanel-0" />
            <Tab label="Run Scan" id="neighbors-subtab-1" aria-controls="neighbors-subpanel-1" />
          </Tabs>
        </Box>
      )}
      <Box role="tabpanel" hidden={allowNeighborsScan && tab !== 0} id="neighbors-subpanel-0" aria-labelledby="neighbors-subtab-0">
        {( !allowNeighborsScan || tab === 0) && (
          <NeighborsReportsList devices={devices} allowNeighborsScan={allowNeighborsScan} />
        )}
      </Box>
      {allowNeighborsScan && (
        <Box role="tabpanel" hidden={tab !== 1} id="neighbors-subpanel-1" aria-labelledby="neighbors-subtab-1">
          {tab === 1 && <NeighborsScanTab devices={devices} />}
        </Box>
      )}
    </Box>
  );
};

export default NeighborsTabContainer;
